import React, { type ComponentProps, type FC } from 'react';
import { ElementFactory, Question, Serializer } from 'survey-core';
import { ReactQuestionFactory } from 'survey-react-ui';

import PhoneNumberVerification from '../../components/phoneNumberVerification';

const PHONE_NUMBER_VERIFICATION_TYPE = 'phone-number-verification';

export class QuestionPhoneVerificationModel extends Question {
  getType() {
    return PHONE_NUMBER_VERIFICATION_TYPE;
  }
}

export const bootPhoneNumberVerificationQuestion = () => {
  // Add question type metadata for further serialization into JSON
  Serializer.addClass(
    PHONE_NUMBER_VERIFICATION_TYPE,
    [],
    () => {
      return new QuestionPhoneVerificationModel('');
    },
    'question',
  );

  ElementFactory.Instance.registerElement(
    PHONE_NUMBER_VERIFICATION_TYPE,
    (name) => {
      return new QuestionPhoneVerificationModel(name);
    },
  );

  ReactQuestionFactory.Instance.registerQuestion(
    PHONE_NUMBER_VERIFICATION_TYPE,
    (props) => {
      return React.createElement<ComponentProps<any>>(
        PhoneNumberVerification as FC,
        props,
      );
    },
  );
};
